export default __webpack_public_path__ + "static/externalImg1-a202a5dba2df2ee6829d3ddcdc26af16.webp";